var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-img',{class:_vm.cssClass,attrs:{"rounded":_vm.rounded,"width":_vm.width,"height":_vm.height,"src":_vm.enderecoImagem,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }